import { attachAsurionIdentity } from './identities/asurionId';
import { dispatchLifecycleEvents } from './lifecycle';

const initialize = async () => {
  await attachAsurionIdentity();
  dispatchLifecycleEvents();
};

export default initialize;
